import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';

import IMAGES from 'shared/constants/images';
import Button from 'shared/modules/common/components/atoms/Button';

type Props = {
  onPress: () => void;
};

const PinCodeLockOut = (props: Props) => {
  return (
    <View style={style.root}>
      <View>
        <Text style={[style.text, style.title]}>
          アカウントがロックされています
        </Text>
        <Text style={style.text}>
          連続で間違った認証コードが入力されました。お客様情報の安全性を確保するため、アカウントがロックされています。数分後にもう一度お試しください。
        </Text>
      </View>
      <Image source={{ uri: IMAGES.exclamation }} style={style.image} />
      <Button
        title="再ログインする"
        onPress={props.onPress}
        id="back-to-signin-button"
      />
    </View>
  );
};

const style = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'space-between',
  },
  text: {
    marginBottom: 8,
  },
  title: {
    fontSize: 21,
    fontWeight: 'bold',
  },
  image: {
    width: 100,
    height: 100,
    alignSelf: 'center',
  },
});

export default PinCodeLockOut;
